<template>
    <div class="sty-header" :class="bemFacets">
        <div class="grid__row">
            <div class="grid__col">
                <slot/>
            </div>
        </div>
    </div>
</template>

<script>
    import { bemMixin } from '@dreipol/vue-ui/src/mixins';

    export default {
        mixins: [
            bemMixin('sty-header'),
        ],
        props: {
            facets: {
                type: Array,
                default() {
                    return ['base'];
                },
            },
        },
    };
</script>
